import React from 'react';

const PaginacionInicio = ({
    currentPage,
    totalPages,
    itemsPerPage,
    totalItems,
    onPageChange,
    onItemsPerPageChange
}) => {
    // Generar números de página para mostrar
    const getPageNumbers = () => {
        const pageNumbers = [];
        const maxVisiblePages = 5;
        
        if (totalPages <= maxVisiblePages) {
            // Si hay pocas páginas, mostrarlas todas
            for (let i = 1; i <= totalPages; i++) {
                pageNumbers.push(i);
            }
        } else {
            // Mostrar siempre la primera página
            pageNumbers.push(1);
            
            // Calcular los puntos suspensivos y páginas intermedias
            let startPage = Math.max(2, currentPage - 1);
            let endPage = Math.min(totalPages - 1, currentPage + 1);
            
            // Ajustar si estamos cerca del inicio o del final
            if (currentPage <= 3) {
                endPage = 4;
            } else if (currentPage >= totalPages - 2) {
                startPage = totalPages - 3;
            }
            
            // Agregar puntos suspensivos después de la primera página si es necesario
            if (startPage > 2) {
                pageNumbers.push('...');
            }
            
            // Agregar páginas intermedias
            for (let i = startPage; i <= endPage; i++) {
                if (i > 1 && i < totalPages) {
                    pageNumbers.push(i);
                }
            }
            
            // Agregar puntos suspensivos antes de la última página si es necesario
            if (endPage < totalPages - 1) {
                pageNumbers.push('...');
            }
            
            // Mostrar siempre la última página
            if (totalPages > 1) {
                pageNumbers.push(totalPages);
            }
        }
        
        return pageNumbers;
    };

    // Calcular índices de elementos mostrados
    const indexOfFirstItem = (currentPage - 1) * itemsPerPage + 1;
    const indexOfLastItem = Math.min(currentPage * itemsPerPage, totalItems);

    return (
        <div className="bg-white dark:bg-gray-900 px-4 py-3 flex flex-col sm:flex-row items-center justify-between border-t border-gray-200 dark:border-gray-700 sm:px-6">
            {/* Mostrar selector de cantidad de items por página */}
            <div className="mb-2 sm:mb-0">
                <div className="flex items-center">
                    <label htmlFor="pageSize" className="text-sm text-gray-600 mr-2">
                        Mostrar:
                    </label>
                    <select
                        id="itemsPerPage"
                        value={itemsPerPage}
                        onChange={onItemsPerPageChange}
                        className="mt-1 block w-full pl-3 pr-10 py-1 text-base border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md dark:bg-gray-700 dark:text-white dark:border-gray-600"
                    >
                        <option value={5}>5</option>
                        <option value={10}>10</option>
                        <option value={20}>20</option>
                        <option value={50}>50</option>
                    </select>
                    <span className="ml-2 text-sm text-gray-600">registros</span>
                </div>
            </div>

            

            {/* Mostrar información de elementos mostrados */}
            {/*<div className="hidden sm:block mb-4 sm:mb-0">
                <p className="text-sm text-gray-700 dark:text-gray-300">
                    Mostrando <span className="font-medium">{indexOfFirstItem}</span> a{' '}
                    <span className="font-medium">{indexOfLastItem}</span> de{' '}
                    <span className="font-medium">{totalItems}</span> resultados
                </p>
            </div>*/}

            <div className="flex-1 flex justify-between sm:justify-end items-center">
                {/* Contador de registros en el centro */}
                <div className="hidden sm:block mb-4 sm:mb-0">
                <p className="text-sm text-gray-700 dark:text-gray-300">
                    Mostrando <span className="font-medium">{indexOfFirstItem}</span> a{' '}
                    <span className="font-medium">{indexOfLastItem}</span> de{' '}
                    <span className="font-medium">{totalItems}</span> resultados
                </p>
            </div>
            </div>
            
            <div className="flex-1 flex justify-between sm:justify-end items-center">
                {/* Selector de items por página */}
                {/*<div className="flex items-center mr-4">
                    <label htmlFor="itemsPerPage" className="mr-2 text-sm text-gray-700 dark:text-gray-300">
                        Mostrar:
                    </label>
                    <select
                        id="itemsPerPage"
                        value={itemsPerPage}
                        onChange={onItemsPerPageChange}
                        className="block w-20 pl-3 pr-10 py-1.5 text-base border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md dark:bg-gray-700 dark:text-white dark:border-gray-600"
                    >
                        <option value={5}>5</option>
                        <option value={10}>10</option>
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                    </select>
                </div>*/}
                
                {/* Navegación de páginas */}
                <nav className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" aria-label="Pagination">
                    {/* Botón Primera Página */}
                    <button
                        onClick={() => onPageChange(1)}
                        disabled={currentPage === 1}
                        className="px-3 py-1 rounded border disabled:opacity-50"
                        aria-label="Primera página"
                    >
                        «
                    </button>
                    {/* Botón Anterior */}
                    <button
                        onClick={() => onPageChange(Math.max(1, currentPage - 1))}
                        disabled={currentPage === 1}
                        className={`relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 dark:border-gray-600 text-sm font-medium ${
                            currentPage === 1 
                                ? 'bg-gray-100 text-gray-400 cursor-not-allowed dark:bg-gray-800 dark:text-gray-500' 
                                : 'bg-white text-gray-500 hover:bg-gray-50 dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600'
                        }`}
                    >
                        <span className="sr-only">Anterior</span>
                        <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                            <path fillRule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clipRule="evenodd" />
                        </svg>
                    </button>
                    
                    {/* Números de página */}
                    {getPageNumbers().map((pageNumber, index) => (
                        <button
                            key={index}
                            onClick={() => typeof pageNumber === 'number' && onPageChange(pageNumber)}
                            disabled={pageNumber === '...'}
                            className={`relative inline-flex items-center px-4 py-2 border text-sm font-medium ${
                                pageNumber === currentPage
                                    ? 'z-10 bg-blue-50 border-blue-500 text-blue-600 dark:bg-blue-900 dark:border-blue-700 dark:text-blue-200'
                                    : 'bg-white border-gray-300 text-gray-500 hover:bg-gray-50 dark:bg-gray-700 dark:border-gray-600 dark:text-gray-300 dark:hover:bg-gray-600'
                            } ${pageNumber === '...' ? 'cursor-default' : 'cursor-pointer'}`}
                        >
                            {pageNumber}
                        </button>
                    ))}
                    
                    {/* Botón Siguiente */}
                    <button
                        onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}
                        disabled={currentPage === totalPages}
                        className={`relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 dark:border-gray-600 text-sm font-medium ${
                            currentPage === totalPages 
                                ? 'bg-gray-100 text-gray-400 cursor-not-allowed dark:bg-gray-800 dark:text-gray-500' 
                                : 'bg-white text-gray-500 hover:bg-gray-50 dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600'
                        }`}
                    >
                        <span className="sr-only">Siguiente</span>
                        <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                            <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                        </svg>
                    </button>
                    {/* Botón Última Página */}
                    <button
                        onClick={() => onPageChange(totalPages)}
                        disabled={currentPage === totalPages}
                        className="px-3 py-1 rounded border disabled:opacity-50"
                        aria-label="Última página"
                    >
                        »
                    </button>
                </nav>
            </div>
        </div>
    );
};

export default PaginacionInicio;
